import {DTNode, DTSocialCreativeNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {ServerNode} from 'common/src/modules/nodes/nodes.types';
import {serializeCreativeNode} from 'common/src/modules/campaigns/utils/serializeConceptCreativeNode';
import {CreativeTemplateType} from '../../creativeTemplates/creativeTemplates.types';
import {SnapchatAdType} from '../../externalAds/externalAds.types';

const getSnapchatAdTypeByCreativeTemplateType = (templateType: CreativeTemplateType) => {
  switch (templateType) {
    case CreativeTemplateType.ImageAds:
      return SnapchatAdType.SnapchatImage;
    case CreativeTemplateType.VideoAds:
      return SnapchatAdType.SnapchatVideo;
    default:
      return undefined;
  }
};

export function serializeSnapchatCreativeNode(node: DTNode, newNode: ServerNode) {
  const creativeNode = node as DTSocialCreativeNode;

  return {
    ...serializeCreativeNode(node, newNode),
    type: creativeNode.type,
    externalAdHeadline: creativeNode.externalAdHeadline || [],
    externalAdCTA: creativeNode.externalAdCTA,
    displayUrl: creativeNode.displayUrl,
    identity: creativeNode.identity,
    additionalIdentity: creativeNode.additionalIdentity,
    trackingPixel: creativeNode.trackingPixel,
    adNameTemplate: creativeNode.adNameTemplate || null,
    mediaNameTemplate: creativeNode.mediaNameTemplate || null,
    brandName: creativeNode.brandName,
    isShareable: creativeNode.isShareable,
    isStandardButtonColor: creativeNode.isStandardButtonColor,
    isPublicPosts: creativeNode.isPublicPosts,
    adType: getSnapchatAdTypeByCreativeTemplateType(creativeNode.creative.template.type),
    clickTrackers: creativeNode.clickTrackers || [],
    impressionTrackers: creativeNode.impressionTrackers || [],
  };
}

